import type { ReactNode } from 'react';

/**
 * A single metric tile. Composes inside a `.kpi-grid` for a responsive dashboard
 * grid, or flows inline on screens that don't wrap it. Pass `onClick` to make the
 * tile an actionable button (keyboard focus + Enter/Space handled for free).
 */
export function Kpi({
  label,
  value,
  tone = 'default',
  hint,
  onClick,
  title,
}: {
  label: ReactNode;
  value: ReactNode;
  tone?: 'default' | 'good' | 'bad' | undefined;
  hint?: ReactNode | undefined;
  onClick?: (() => void) | undefined;
  title?: string | undefined;
}) {
  const cls = ['kpi', tone !== 'default' ? `kpi-${tone}` : '', onClick ? 'kpi-click' : '']
    .filter(Boolean)
    .join(' ');
  const inner = (
    <>
      <span className="kpi-label">{label}</span>
      <b className="kpi-value">{value}</b>
      {hint ? <span className="kpi-hint">{hint}</span> : null}
    </>
  );
  return onClick ? (
    <button type="button" className={cls} onClick={onClick} title={title}>
      {inner}
    </button>
  ) : (
    <div className={cls}>{inner}</div>
  );
}
